// @ts-strict-ignore
import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

type State = {
  updateRequired: boolean;
};

export const UpdateRequiredContext = React.createContext<boolean>(false);

export class UpdateRequiredContextProvider extends React.PureComponent<
  Props,
  State
> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    updateRequired: false,
  };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pageData: { landingSearch?: Object; }; } |... Remove this comment to see the full error message
    window.Idealist = window.Idealist || {};

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forceUpdate' does not exist on type '{ p... Remove this comment to see the full error message
    window.Idealist.forceUpdate = () => {
      this.setState({
        updateRequired: true,
      });
      return true;
    };
  }

  render() {
    return (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      <UpdateRequiredContext.Provider value={this.state.updateRequired}>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.children}
      </UpdateRequiredContext.Provider>
    );
  }
}
